import { FormattedMessage } from 'react-intl';

import { DropdownMenuType } from 'ui-components/components/dropdown-menu/dropdown-menu-type';
import { DropdownMenuPosition } from 'ui-components/components/INTERNAL/dropdown/dropdown-menu-position';
import { Text, TextType } from 'ui-components/components/text';

import style from './configure-shipment-section-header-content.module.less';
import { messages } from './messages';
import PresetContainer from '../../../../fulfillment-planner/presets/container';
import { useIsFedexHALByFulfillmentPlanId } from '../../../../hooks/orders/use-fedex-hal-check';
import ShipDate from '../../../../orders/order-details/configure-shipment/fields/ship-date/ship-date';

/**
 * @param {object} props
 * @param {string} props.fulfillmentPlanId
 * @param {boolean} props.isSectionExpanded
 * @param {boolean} props.shouldShowShipmentWidget
 * @returns {JSX.Element}
 */
export const ConfigureShipmentSectionHeaderContent = ({ fulfillmentPlanId, isSectionExpanded, shouldShowShipmentWidget }) => {
  const isFedexHalShipment = useIsFedexHALByFulfillmentPlanId(fulfillmentPlanId);
  const shouldShowShipDate = shouldShowShipmentWidget && isSectionExpanded;
  const shouldShowPresets = shouldShowShipmentWidget && isSectionExpanded && !isFedexHalShipment;

  return (
    <div className={style['header-content']}>
      <Text textType={TextType.H4} value={messages.shippingSectionTitle} />
      <div className={style['header-actions']}>
        {shouldShowShipDate ? (
          <ShipDate dropdownIconClassName={style['ship-date-dropdown-icon']} linkButtonClassName={style['action-dropdown']} />
        ) : null}
        {shouldShowPresets ? (
          <PresetContainer
            dropdownMenuType={DropdownMenuType.Menu}
            dropdownTogglerClassName={style['action-dropdown']}
            dropdownTogglerMessage={<FormattedMessage {...messages.preset} />}
            fulfillmentPlanId={fulfillmentPlanId}
            menuPosition={DropdownMenuPosition.BottomRight}
          />
        ) : null}
      </div>
    </div>
  );
};
